type Error = {
  section: string;
  message: string;
  timestamp: Date;
  category?: string;
};

export class ErrorLogger {
  private errors: Error[] = [];

  log(section: string, message: string, category?: string) {
    const isDuplicate = this.errors.some(
      (error) => error.section === section && error.message === message && error.category === category,
    );

    if (!isDuplicate) {
      this.errors.push({
        section,
        message,
        timestamp: new Date(),
        category,
      });
    }
  }

  getErrors(): Error[] {
    return this.errors;
  }

  getErrorsByCategory(category: string): Error[] {
    return this.errors.filter((e) => e.category === category);
  }

  hasErrorsByCategory(category: string): boolean {
    return this.errors.some((error) => error.category === category);
  }

  hasErrors(): boolean {
    return this.errors.length > 0;
  }
  clearErrorBySection(section: string) {
    this.errors = this.errors.filter((e) => e.section !== section);
  }
  clear() {
    this.errors = [];
  }
}

export const errorLogger = new ErrorLogger();
